var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-sliders_2_",
    "data-name": "settings-sliders(2)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M.75,3.562H2.8a2.8,2.8,0,0,0,5.4,0H17.25a.75.75,0,0,0,0-1.5H8.2a2.8,2.8,0,0,0-5.4,0H.75a.75.75,0,1,0,0,1.5ZM5.5,1.5A1.312,1.312,0,1,1,4.187,2.812,1.312,1.312,0,0,1,5.5,1.5Z",
    transform: "translate(0 0)",
    fill: "#6b87b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5018",
    "data-name": "Path 5018",
    d: "M17.25,10.312H15.2a2.8,2.8,0,0,0-5.4,0H.75a.75.75,0,1,0,0,1.5H9.8a2.8,2.8,0,0,0,5.4,0H17.25a.75.75,0,0,0,0-1.5ZM12.5,12.375a1.312,1.312,0,1,1,1.312-1.312A1.312,1.312,0,0,1,12.5,12.375Z",
    transform: "translate(0 -2.062)",
    fill: "#6b87b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5019",
    "data-name": "Path 5019",
    d: "M17.25,18.562H8.2a2.8,2.8,0,0,0-5.4,0H.75a.75.75,0,0,0,0,1.5H2.8a2.8,2.8,0,0,0,5.4,0H17.25a.75.75,0,0,0,0-1.5ZM5.5,20.625a1.312,1.312,0,1,1,1.312-1.312A1.312,1.312,0,0,1,5.5,20.625Z",
    transform: "translate(0 -4.125)",
    fill: "#6b87b0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.65960d99319cbebd3ba1c42e95d3d587.svg";
export { ForwardRef as ReactComponent };